<template>
  <div class="invoice-template a4">
    <component :is="template" :client="client" :invoice="invoice" :user="user" :company="company" class="a4">
      <img class="invoice-image-template" :src="url">
    </component>
  </div>
</template>

<script>
import moment from "moment";
import { storage } from "@/firebase";
import store from "../../store"
export default {
  name: "Invoice",
  props: ["invoice"],
  data () {
    return {
      moment: moment,
      template: null,
      user: this.$store.getters.currentUser,
      url: "",
      subTotalWithoutDiscount () {
        let subTotal = 0;
        for (let article of this.invoice.articles) {
          subTotal += article.price_unit * article.quantity;
        }
        return +(Math.round(subTotal + "e+2") + "e-2");
      },
      discount () {
        if (this.invoice.discount) {
          return (this.subTotalWithoutDiscount() / 100) * this.invoice.discount;
        }
        return 0;
      },
      subTotal () {
        let subTotal = 0;
        if (this.invoice.articles) {
          for (let article of this.invoice.articles) {
            subTotal += article.price_unit * article.quantity;
          }
        }
        return +(Math.round(subTotal - this.discount() + "e+2") + "e-2");
      },
      vat () {
        let vat = (this.subTotal() / 100) * this.invoice.vat_percentage;
        return +(Math.round(vat + "e+2") + "e-2");
      },
      total () {
        let total = this.subTotal() + this.vat();
        return +(Math.round(total + "e+2") + "e-2");
      }
    };
  },
  mounted () {
    this.template = () => this.loadTemplate();
    let url = this.invoice.template ? this.invoice.template.ref : null
    this.loadUrl(url)
  },
  watch: {
    invoiceTemplate() {
      this.template = () => this.loadTemplate();
      let url = this.invoice.template ? this.invoice.template.ref : null
      this.url = this.loadUrl(url)
    }
  },
  computed: {
    invoiceTemplate() {
      return this.invoice.template
    },
    loadTemplate () {
      if(this.invoice.template && this.invoice.template.id) {
        return () => import(`../../templates/${this.user.organisation}/${this.invoice.template.id}.vue`)
      } else {
        return () => import(`../../templates/_default/default-template-v1.vue`)
      }
    },
    client () {
      return this.$store.getters.clientById(this.invoice.client_id);
    },
    company () {
      return this.$store.getters.company || {};
    },
    showDate () {
      for (let article of this.invoice.articles) {
        if (moment(article.date).isValid()) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    calculateArticleTotal (article) {
      let articleTotal = article.price_unit * article.quantity;
      return +(Math.round(articleTotal + "e+2") + "e-2");
    },
    async loadUrl(url) {
      if (!url) {
        url = `_default/templates/default-template-v1.svg`
      }

      let id = "default-template-v1"
      if (this.invoice.template) id = this.invoice.template.id

      if (!sessionStorage[id]) {
        const toDataURL = url =>
          fetch(url)
            .then(response => response.blob())
            .then(
              blob =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                })
            );

        let pathReference = storage.ref(url);
        try {
          let data = await pathReference.getDownloadURL()
          this.url = data

          let dataURI = await toDataURL(data)
          sessionStorage[id] = dataURI

          store.dispatch("addFlashMessage", {
            type: "success",
            message: "Template loaded",
            icon: "fa-monkey",
            closable: true,
            timeout: 3000,
          });
        } catch (e) {
          store.dispatch("addFlashMessage", {
            type: "error",
            message: "Something went wrong loading the invoice template",
            icon: "fa-unicorn",
            closable: true
          });
        }
      } else {
        this.url = await sessionStorage[id]
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
.invoice-template {
  border: 1px solid $color-border;
  border-radius: 4px;
  position: relative;
}

.invoice-image-template {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
}

@media print {
  .invoice-template {
    border: none;
    box-sizing: border-box;
  }
}

</style>
